<template>
  <div class="delivery-parcel-item-wrap">
    <div
      v-for="(deliveryParcelItem, deliveryParcelIndex) in deliveryList"
      :key="deliveryParcelIndex"
    >
      <div class="mt-16 ml-24 mr-24 clearfix">
        <!-- <div class="fl">
          {{
            deliveryParcelItem.merchantAlias
              ? deliveryParcelItem.merchantAlias
              : `仓库${deliveryParcelItem.sellerCode || ""}`
          }}
        </div> -->
        <div class="fl">
          {{
            deliveryParcelItem.merchantAlias
              ? `${TLang('包裹', 'list')}${deliveryParcelIndex + 1}-${
                  deliveryParcelItem.merchantAlias
                }`
              : `${TLang('包裹', 'list')}${deliveryParcelIndex + 1}-${TLang('仓库', 'list')}`
          }}
        </div>
        <div :class="['fr', deliveryParcelItem.fontColor]">
          {{ TLang(deliveryParcelItem.title, 'order') }}
        </div>
      </div>
      <div class="order-thead text-c666 mt-12 clearfix">
        <div class="fl">{{TLang('商品信息','orderConfirm')}}</div>
        <div class="fl">{{TLang('单价','orderConfirm')}}{{getCurrentUnionName(union_name )}}</div>
        <div class="fl">{{TLang('数量','orderConfirm')}}</div>
        <div class="fr">{{TLang('金额','orderConfirm')}}{{getCurrentUnionName(union_name )}}</div>
      </div>

      <div class="order-tbody">
        <!-- 遍历商品订单 -->
        <div
          v-for="goodsItem in deliveryParcelItem.goodsList"
          :key="goodsItem.goodsId"
          class="order-tbody-item clearfix"
        >
          <div class="fl clearfix">
            <div class="product-img mr-12 fl">
              <img
                :src="goodsItem.goodsImgGuide"
                alt="product img"
                class="order-img"
              />
              <!-- 爆炸贴图片 -->
              <Sticker :imgList="goodsItem.stickerImgList" />
            </div>
            <div
              class="fl"
              style="max-width: 410px;"
            >
              <div
                class="text-c111 line-clamp-1"
                :class="goodsItem.giftType != 2 ? 'hover' : ''"
                style="max-width: 410px"
                @click="navigatorProductDetal(goodsItem)"
              >
                <i
                  :style="{ fontStyle: 'normal'}"
                >
                  <SingleTag :show="goodsItem.giftType == 4" :datas="{name: TLang('奖品', 'list')}" :putName="'PrizeGoods'" />
                </i>
                <i
                  v-for="(tag, index) in goodsItem.tags"
                  :key="index"
                  :style="{ fontStyle: 'normal'}"
                >
                  <SingleTag :show="tag.mktFrontType === 9005" :datas="tag" />
                </i>
                <!-- {{ goodsItem.goodsName }} -->
                {{ goodsItem.giftType == 2 ? goodsItem.specValue : goodsItem.goodsName }}
              </div>
              <div class="text-c999 mt-8" v-if="goodsItem.giftType != 2">{{ TLang('规格','orderConfirm') }}：{{ goodsItem.specValue }}</div>
              <div class="text-c999 mt-8 birthdayAnnex" v-if="goodsItem.birthdayAnnex">{{ TLang('配件','orderConfirm') }}：{{ goodsItem.birthdayAnnex }}</div>
              <div class="text-c999 mt-8" v-if="goodsItem.birthdayRemark">{{ TLang('生日字牌','orderConfirm') }}：{{ goodsItem.birthdayRemark }}</div>
              <!-- <div class="mt-28">
              <label class="label-fill-theme font-s11">预售</label>
              <span><em class="font-num">2018.11.12 10:00:00</em>发货</span>
            </div> -->

              <!-- 营销工具 等待订单接口 -->
              <!-- "mktFrontType":"前台促销类型，1001：单一特价，1002：单一折扣，1003：单一直降，1004：抢购", -->
              <!-- <div class="mt-28">
                <label class="label-fill-theme font-s11">特价</label>
              </div>
              <div class="mt-28">
                <label class="label-fill-theme font-s11">抢购</label>
              </div> -->
            </div>
          </div>
          <div class="text-num fl">
            <span v-if="isShowPrice === 1">{{
              parseFloat((goodsItem.goodsPrice * union_scale).toFixed(2))
            }}</span>
            <span v-else>&nbsp;</span>
          </div>
          <div class="text-num fl">
            {{ goodsItem.quantity }}
          </div>
          <div class="text-num fr">
            <span v-if="isShowPrice === 1">
              {{ parseFloat((goodsItem.totalPrice * union_scale).toFixed(2)) }}
            </span>
            <span v-else>&nbsp;</span>
          </div>
        </div>
      </div>
      <orderFooter
        :orderInfo="orderInfo"
        :deliveryParcelItem="deliveryParcelItem"
        :deliveryParcelIndex="deliveryParcelIndex"
        :isShowPrice="isShowPrice"
      />
    </div>
  </div>
</template>

<script>
import orderFooter from "./orderFooter";
import Sticker from "@components/sticker";
import SingleTag from '@components/singleTag';
export default {
  name: "DeliveryParcelItem",
  components: {
    orderFooter,
    Sticker,
    SingleTag,
  },
  props: {
    orderInfo: Object,
    deliveryList: Array,
    isShowPrice: Number,
  },
  updated() {},

  methods: {
    navigatorProductDetal(item) {
      if(item.channel==7 && this.orderInfo.orderType == 2){  // 订单类型：1体检订单，2商城购物 3booking) channel =7 礼包
        this.$message({
          message: '请至移动端体验下单',
          type: 'warning'
        });
        return
      }
      if (item.giftType != 2) {
        this.$parent.navigatorProductDetal &&
          this.$parent.navigatorProductDetal(item);
      }
    },
    // 获取当前单位字符
    getCurrentUnionName(union_name){
      if(this.orderInfo && this.orderInfo.groupItem === 'Y'){
        if(this.orderInfo.groupItemShowRmbSymbol === 'Y'){
          return `(${TLang('元','orderConfirm')})`;
        } else {
          return '';
        }
      } else {
        return `(${union_name})`;
      }
    },
  },
};
</script>

<style lang="less" scope>
@wrap-background: #f7f7f7;
@card-background-theme: #f8fcff;
@card-background-default: #f7f7f7;

.hover {
  &:hover {
    color: #3d96e2;
    cursor: pointer;
  }
}

.delivery-parcel-item-wrap {
  .order-thead,
  .order-tbody > div.order-tbody-item {
    & > :nth-of-type(1) {
      width: 46.17%;
    }
    & > :nth-of-type(2) {
      width: 23.75%;
    }
    & > :nth-of-type(3) {
      width: 18%;
    }
    & > :nth-of-type(4) {
      width: 123px;
      text-align: right;
    }
  }
  .order-tbody {
    padding: 16px 24px;
    .order-tbody-item {
      border-bottom: solid 1px #f7f7f7;
      padding: 16px 0;
      &:last-of-type {
        border: none;
      }
      &:first-of-type {
        padding-top: 0;
      }
    }
    .product-img {
      width: 90px;
      height: 90px;
      position: relative;
      .order-img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .order-tfooter {
    padding: 24px 24px 16px;
    background-color: @wrap-background;
    position: relative;
    .order-tfooter-item {
      text-align: right;
      span {
        display: inline-block;
      width: calc(100% - 300px);
        vertical-align: text-top;
        &:last-of-type {
        width: 290px;
          text-align: right;
        }
      }
      i {
        font-style: normal;
        margin-right: 8px;
      }
      .fontBlack {
        color: #333;
      }
      .fontBlue {
        color: #3FA6FF;
      }
      .fontOrange {
        color: #FF6600;
      }
    }
  }
  .birthdayAnnex {
    max-width: 420px;
    word-wrap:break-word;
    overflow: hidden;
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 2;
  }
}
</style>
